import {
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  VirtualEnumValue7ord04id8ran as VirtualEnumValue,
  StringValue3s88kmb638dp as StringValue,
  getElementSerializableAnnotations1pxi95cizsm0v as getElementSerializableAnnotations,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import { titleCase1rwupo9lkd0x6 as titleCase } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/casing.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { listElement3jy3tr2z6og1q as listElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { enumValues198w9mpbetxy6 as enumValues } from './serializerManipulation.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerEnumSet(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, LIST_getInstance()), EnumSetRenderer_instance);
}
function toDisplayName($this, value, serializer) {
  var tmp;
  if (value == null) {
    tmp = 'N/A';
  } else {
    var tmp0_safe_receiver = value instanceof VirtualEnumValue() ? value : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.let' call
      var option = tmp0_safe_receiver.enum_1.options_1.get_c1px32_k$(tmp0_safe_receiver.index_1);
      // Inline function 'kotlin.collections.find' call
      var tmp0 = option.annotations_1;
      var tmp$ret$5;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (element.fqn_1 === 'com.lightningkite.services.data.DisplayName') {
            tmp$ret$5 = element;
            break $l$block;
          }
        }
        tmp$ret$5 = null;
      }
      var tmp0_safe_receiver_0 = tmp$ret$5;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.values_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$('text');
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
      }
      var tmp3_safe_receiver = tmp_1;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
      tmp_0 = tmp4_elvis_lhs == null ? titleCase(option.name_1) : tmp4_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver_0 = value instanceof Enum() ? value : null;
      var tmp_3;
      if (tmp2_safe_receiver_0 == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.find' call
        var tmp0_0 = getElementSerializableAnnotations(serializer, tmp2_safe_receiver_0.ordinal_1);
        var tmp$ret$12;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            if (element_0.fqn_1 === 'com.lightningkite.services.data.DisplayName') {
              tmp$ret$12 = element_0;
              break $l$block_0;
            }
          }
          tmp$ret$12 = null;
        }
        var tmp0_safe_receiver_1 = tmp$ret$12;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.values_1;
        var tmp2_safe_receiver_1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.get_wei43m_k$('text');
        var tmp_4;
        if (tmp2_safe_receiver_1 == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_4 = tmp2_safe_receiver_1 instanceof StringValue() ? tmp2_safe_receiver_1 : null;
        }
        var tmp3_safe_receiver_0 = tmp_4;
        var tmp4_elvis_lhs_0 = tmp3_safe_receiver_0 == null ? null : tmp3_safe_receiver_0.value_1;
        tmp_3 = tmp4_elvis_lhs_0 == null ? titleCase(tmp2_safe_receiver_0.name_1) : tmp4_elvis_lhs_0;
      }
      tmp_2 = tmp_3;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_2;
    tmp = tmp3_elvis_lhs == null ? titleCase(toString(value)) : tmp3_elvis_lhs;
  }
  return tmp;
}
function EnumSetRenderer$form$lambda$lambda($enumValue) {
  return (it) => it.contains_aljjnj_k$($enumValue);
}
function EnumSetRenderer$form$lambda$lambda_0($enumValue) {
  return (original, checked) => checked ? plus(original, $enumValue) : minus(original, $enumValue);
}
var EnumSetRendererClass;
function EnumSetRenderer() {
  if (EnumSetRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Checkboxes';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_wxiuk5_k$(context, module_0) {
        var descriptor = context.serializer_1.get_descriptor_wjt6a0_k$();
        if (!equals(descriptor.get_kind_wop7ml_k$(), LIST_getInstance()) || !contains(descriptor.get_serialName_u2rqhk_k$(), 'Set'))
          return -1.0;
        var tmp0_elvis_lhs = listElement(context.serializer_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1.0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var elementSerializer = tmp;
        if (!equals(elementSerializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), ENUM_getInstance()))
          return -1.0;
        return 0.95;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_wxiuk5_k$(context, module_0);
      }
      form_icvn38_k$(context, value, module_0) {
        var tmp = listElement(context.serializer_1);
        var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
        var enumValues_0 = enumValues(elementSerializer);
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          var _iterator__ex2g4s = enumValues_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var enumValue = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            element.willAddChild_hz2iwc_k$(element_0);
            element_0.set_vertical_nuap32_k$(false);
            // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (Checkbox())(element_0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            element_0.willAddChild_hz2iwc_k$(element_1);
            var tmp = EnumSetRenderer$form$lambda$lambda(enumValue);
            element_1.bind_gesskf_k$(element_1.checked_1, value.lens_u4wb4z_k$(tmp, EnumSetRenderer$form$lambda$lambda_0(enumValue)));
            element_1.onStartup_vrxh3i_k$();
            element_0.addChild_2qpft2_k$(element_1);
            text(element_0, toDisplayName(EnumSetRenderer_instance, enumValue, elementSerializer));
            element_0.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_0);
          }
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_icvn38_k$(context, value, module_0);
      }
      view_l231d_k$(context, value, module_0) {
        var tmp = listElement(context.serializer_1);
        var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var set = $this$invoke.invoke_r7m7el_k$(value);
            var tmp;
            if (set.isEmpty_y1axqb_k$()) {
              tmp = 'None';
            } else {
              tmp = joinToString(set, ', ', VOID, VOID, VOID, VOID, (it) => toDisplayName(EnumSetRenderer_instance, it, elementSerializer));
            }
            return tmp;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_l231d_k$(context, value, module_0);
      }
      cellView_pretst_k$(context, value, module_0) {
        var tmp = listElement(context.serializer_1);
        var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var set = $this$invoke.invoke_r7m7el_k$(value);
            var tmp;
            if (set.isEmpty_y1axqb_k$()) {
              tmp = 'None';
            } else {
              tmp = joinToString(set, ', ', VOID, VOID, VOID, VOID, (it) => toDisplayName(EnumSetRenderer_instance, it, elementSerializer));
            }
            return tmp;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_pretst_k$(context, value, module_0);
      }
      columnWidth_m1om8x_k$(context, module_0) {
        return 15.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_m1om8x_k$(context, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'EnumSetRenderer', VOID, VOID, [Renderer()]);
    EnumSetRendererClass = $;
  }
  return EnumSetRendererClass;
}
var EnumSetRenderer_instance;
function EnumSetRenderer_getInstance() {
  return EnumSetRenderer_instance;
}
//region block: init
EnumSetRenderer_instance = new (EnumSetRenderer())();
//endregion
//region block: exports
export {
  registerEnumSet as registerEnumSet1xu98s984a356,
};
//endregion

//# sourceMappingURL=EnumSetRenderer.mjs.map
